import React, { useEffect, useState } from 'react';
import StreamViewer from './StreamViewer';
import styles from './StreamList.module.css';

const StreamList = () => {
  const apiUrl = process.env.REACT_APP_STREAM_API_URL;

  const [streams, setStreams] = useState([]);
  const [selectedStream, setSelectedStream] = useState(null);

  useEffect(() => {
    const fetchStreams = async () => {
      try {
        const res = await fetch(`${apiUrl}/streams`, {mode: 'cors'});
        const data = await res.json();
        setStreams(data);

        const currentStillValid = data.find(s => s.streamId === selectedStream?.streamId);
        const newSelected = data.length > 0 ? (currentStillValid || data[0]) : null;

        if ((selectedStream?.streamId || null) !== (newSelected?.streamId || null)) {
          setSelectedStream(newSelected);
        }
      } catch (err) {
        console.error('Error fetching streams:', err);
        setStreams([]);
        setSelectedStream(null);
      }
    };

    fetchStreams();
    // const interval = setInterval(fetchStreams, 5000);
    // return () => clearInterval(interval);
    return;
  }, []);

  if (!selectedStream) {
    return (
      <div className={styles.noStreams}>
        <img src="/no-broadcasts.jpg" alt="No active streams" />
        <p>No broadcasts right now</p>
        <span>Please check back later</span>
      </div>
    );
  }

  const otherStreams = streams.filter(s => s.streamId !== selectedStream.streamId);

  return (
    <div className={styles.streamList}>
      <div className={styles.streamHero}>
        <StreamViewer streamId={selectedStream.streamId} isActive />
      </div>

      {otherStreams.length > 0 && (
        <div className={styles.streamSection}>
          <h2 className={styles.streamSectionTitle}>Available Broadcasts</h2>
          <div className={styles.streamGrid}>
            {otherStreams.map(({ streamId, thumbnail }) => (
              <div
                key={streamId}
                className={styles.streamCard}
                onClick={() => setSelectedStream({ streamId, thumbnail })}
              >
                <img src={thumbnail} alt={`Stream ${streamId}`} />
                <div className={styles.thumbnailOverlay}>Click to view</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StreamList;
